document.addEventListener("DOMContentLoaded", () => {
  // ── Fancy loading ────────────────────────────────────────────
  initLazyHero();

  // ── Scroll reveal (animación de entrada) ─────────────────────
  initScrollReveal();

  // ── Cursor personalizado (desktop) ───────────────────────────
  initCursor();

  // ── Degradado de fondo por scroll ────────────────────────────
  initScrollGradient();

  // ── Reproductor de música ────────────────────────────────────
  initMusicPlayer();

  // ── Cuenta regresiva ─────────────────────────────────────────
  initCountdown();

  // ── Galería de fotos (stack swipeable) ───────────────────────
  initGallery();

  // ── Código de vestimenta ─────────────────────────────────────
  initDresscodeLightbox();

  // ── RSVP con Notion ──────────────────────────────────────────
  initRSVP();

  // ── Efecto de estrellas ──────────────────────────────────────
  initStars();

  // ── Cerrar lightboxes con Escape ─────────────────────────────
  initGalleryKeyboardInteraction();
});

/**
 * Observa los elementos .reveal y les añade .visible
 * cuando entran en el viewport.
 */
function initScrollReveal() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.08 },
  );

  document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
}

/**
 * Agregar un delay al texto dentro del HERO al momento de cargar la pagina (fancy effect)
 */
function initLazyHero() {
  window.addEventListener("load", () => {
    setTimeout(() => {
      document.getElementById("hero").classList.add("hero-loaded");
    }, 70);
  });
}

/**
 * Cerrar lightboxes con Escape
 */
function initGalleryKeyboardInteraction() {
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeGalleryLightbox();
      closeDresscodeLightbox();
    }
  });
}
